export default {
  alt: 'Выберите язык',
  en: {
    alt: 'Английский',
    title: 'Английский',
  },
  es: {
    alt: 'Испанский',
    title: 'Испанский',
  },
  close: {
    alt: 'Закрыть',
  },
  ko: {
    alt: 'Корейский',
    title: 'Корейский',
  },
  zh: {
    alt: 'Китайский',
    title: 'Китайский',
  },
  vi: {
    alt: 'Вьетнамский',
    title: 'Вьетнамский',
  },
  ru: {
    alt: 'Русский',
    title: 'Русский',
  },
  'pt-PT': {
    alt: 'Portuguese (Portugal)',
    title: 'Portuguese (Portugal)',
  },
  'pt-BR': {
    alt: 'Portuguese (Brazil)',
    title: 'Portuguese (Brazil)',
  },
}
